import React from 'react';
import { Typography } from 'antd';
import { formatHistoryDate } from '../../helpers/crmHistoryFormat';

const { Text } = Typography;

interface Props {
  name?: string;
  date?: string;
}

/** Two-line "who / when" cell for list tables. Renders a dash when the record has no stamp. */
const CrmUserStamp: React.FC<Props> = ({ name, date }) => {
  if (!name && !date) return <Text type="secondary">—</Text>;
  return (
    <div className="crm-user-stamp">
      <div>{name || '—'}</div>
      {date && <Text type="secondary" style={{ fontSize: 12 }}>{formatHistoryDate(date)}</Text>}
    </div>
  );
};

export default CrmUserStamp;
